import React, { useState } from 'react';
import './Blog.css';
import blogHeroImage from '../slide3.jpeg';
import searchIcon from '../compass.png';
import calendarIcon from '../calendar.png';
import userIcon from '../user11.png';
import eyeIcon from '../eye.png';
import arrowIcon from '../arrow.png';
import blogImage1 from '../about1.png';
import blogImage2 from '../mission-image.png';
import blogImage3 from '../founder.png';
import blogImage4 from '../gaushala.png';
import blogImage5 from '../veda1.png';
import blogImage6 from '../yoga.png';
import categoryIcon from '../class.png';
import tagIcon from '../mark.png';
import shareIcon from '../at.png';
import fireIcon from '../fire.png';
import starIcon from '../star.png';
import heartIcon from '../heart.png';
import Contact from '../components/Contact';


const Blog = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');

  const blogPosts = [
    {
      id: 1,
      title: "The Sacred Journey of Vedic Learning",
      excerpt: "Discover the ancient wisdom of Vedic education and how it transforms lives through disciplined learning and spiritual growth.",
      content: "The Vedic tradition of learning is not merely about acquiring knowledge; it's about transforming one's entire being.",
      image: blogImage1,
      category: "Vedic Education",
      author: "Sri Veda Gurukulam",
      date: "2024-01-15",
      readTime: "5 min read",
      views: 1250,
      likes: 89,
      featured: true,
      tags: ["Vedic Learning", "Spirituality", "Education"]
    },
    {
      id: 2,
      title: "Understanding Dharma in Modern Times",
      excerpt: "Explore how ancient Dharmic principles can guide us through contemporary challenges and ethical dilemmas.",
      content: "Dharma, the righteous path, remains as relevant today as it was thousands of years ago.",
      image: blogImage2,
      category: "Philosophy",
      author: "Sri Veda Gurukulam",
      date: "2024-01-10",
      readTime: "7 min read",
      views: 980,
      likes: 67,
      featured: false,
      tags: ["Dharma", "Ethics", "Philosophy"]
    },
    {
      id: 3,
      title: "The Guru-Shishya Tradition: A Sacred Bond",
      excerpt: "Learn about the profound relationship between teacher and student in the Vedic tradition.",
      content: "The Guru-Shishya tradition represents one of the most sacred relationships in Vedic culture.",
      image: blogImage3,
      category: "Tradition",
      author: "Sri Veda Gurukulam",
      date: "2024-01-05",
      readTime: "6 min read",
      views: 1450,
      likes: 112,
      featured: false,
      tags: ["Guru-Shishya", "Tradition", "Wisdom"]
    },
    {
      id: 4,
      title: "Yoga and Meditation: Paths to Inner Peace",
      excerpt: "Discover the ancient practices of Yoga and meditation as tools for achieving mental clarity.",
      content: "Yoga and meditation are profound spiritual practices that lead to self-realization.",
      image: blogImage6,
      category: "Yoga & Meditation",
      author: "Sri Veda Gurukulam",
      date: "2023-12-28",
      readTime: "8 min read",
      views: 2100,
      likes: 156,
      featured: true,
      tags: ["Yoga", "Meditation", "Spirituality"]
    },
    {
      id: 5,
      title: "Preserving Ancient Wisdom for Future Generations",
      excerpt: "How we can maintain and pass on the invaluable knowledge of our ancestors.",
      content: "In our rapidly changing world, preserving ancient wisdom becomes crucial.",
      image: blogImage5,
      category: "Heritage",
      author: "Sri Veda Gurukulam",
      date: "2023-12-20",
      readTime: "4 min read",
      views: 875,
      likes: 43,
      featured: false,
      tags: ["Heritage", "Wisdom", "Culture"]
    },
    {
      id: 6,
      title: "The Role of Compassion in Vedic Life",
      excerpt: "Understanding how compassion towards all beings forms the foundation of Vedic philosophy.",
      content: "Compassion is not just an emotion in Vedic philosophy; it's a way of life.",
      image: blogImage4,
      category: "Philosophy",
      author: "Sri Veda Gurukulam",
      date: "2023-12-15",
      readTime: "5 min read",
      views: 1320,
      likes: 78,
      featured: false,
      tags: ["Compassion", "Philosophy", "Dharma"]
    }
  ];

  const categories = ["All", "Vedic Education", "Philosophy", "Tradition", "Yoga & Meditation", "Heritage"];

  const filteredPosts = blogPosts.filter(post => {
    const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'All' || post.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const featuredPosts = filteredPosts.filter(post => post.featured);
  const regularPosts = filteredPosts.filter(post => !post.featured);
  const trendingPosts = [...filteredPosts].sort((a, b) => b.views - a.views).slice(0, 3);
  const popularTags = ['Vedic Learning', 'Spirituality', 'Dharma', 'Philosophy', 'Yoga', 'Meditation', 'Tradition', 'Wisdom'];

  return (
    <div className="blog-page">
      {/* Hero Section */}
      <section className="blog-hero">
        <div className="hero-content">
          <div className="container">
            <div className="hero-text-container">
              
              <h1 className="hero-title">
                <span className="title-line">Ancient Wisdom Modern Insights</span>
              </h1>
              
              
            </div>
          </div>
        </div>
      </section>

      {/* Enhanced Search and Navigation Bar */}
      <section className="blog-navigation">
        <div className="nav-container">
          <div className="nav-content">
            <div className="search-section">
              <div className="search-wrapper">
                <div className="search-box">
                  <img src={searchIcon} alt="Search" className="search-icon" />
                  <input
                    type="text"
                    placeholder="Discover ancient wisdom..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                  />
                  <div className="search-highlight"></div>
                </div>
                <div className="search-suggestions">
                  <span className="suggestion-tag">Dharma</span>
                  <span className="suggestion-tag">Meditation</span>
                  <span className="suggestion-tag">Yoga</span>
                </div>
              </div>
            </div>
            <div className="category-section">
              <div className="category-header">
                <img src={categoryIcon} alt="Categories" className="category-header-icon" />
                <span className="category-header-text">Explore Topics</span>
              </div>
              <div className="category-tabs">
                {categories.map(category => (
                  <button
                    key={category}
                    className={`category-tab ${selectedCategory === category ? 'active' : ''}`}
                    onClick={() => setSelectedCategory(category)}
                  >
                    <span className="tab-text">{category}</span>
                    <div className="tab-indicator"></div>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Enhanced Featured Articles Carousel */}
      {featuredPosts.length > 0 && (
        <section className="featured-section">
          <div className="featured-container">
            <div className="section-header">
              <div className="section-title-wrapper">
               
                <div className="section-title-content">
                  <h2 className="section-title">Featured Wisdom</h2>
                  <p className="section-subtitle">Discover our most profound teachings and insights</p>
                </div>
              </div>
              
            </div>
            
            <div className="featured-showcase">
              <div className="featured-main">
                {featuredPosts.slice(0, 1).map(post => (
                  <article key={post.id} className="main-featured-card">
                    <div className="featured-image-wrapper">
                      <img src={post.image} alt={post.title} className="featured-image" />
                      <div className="featured-overlay">
                        <div className="featured-badges">
                          <div className="featured-badge">
                            <img src={starIcon} alt="Featured" />
                            <span>Featured</span>
                          </div>
                          <div className="engagement-stats">
                            <div className="stat-item">
                              <img src={eyeIcon} alt="Views" />
                              <span>{post.views}</span>
                            </div>
                            <div className="stat-item">
                              <img src={heartIcon} alt="Likes" />
                              <span>{post.likes}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-meta">
                        <span className="category-pill">{post.category}</span>
                        <div className="meta-divider"></div>
                        <span className="read-time">{post.readTime}</span>
                      </div>
                      <h3 className="featured-title">{post.title}</h3>
                      <p className="featured-excerpt">{post.excerpt}</p>
                      <div className="featured-footer">
                        <div className="author-info">
                          <div className="author-avatar">
                            <img src={userIcon} alt="Author" />
                          </div>
                          <div className="author-details">
                            <span className="author-name">{post.author}</span>
                            <span className="post-date">{new Date(post.date).toLocaleDateString()}</span>
                          </div>
                        </div>
                        <button className="read-btn">
                          <span>Read Article</span>
                          <img src={arrowIcon} alt="Arrow" />
                        </button>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
              
              <div className="featured-sidebar">
                {featuredPosts.slice(1).map(post => (
                  <article key={post.id} className="side-featured-card">
                    <div className="side-image-container">
                      <img src={post.image} alt={post.title} className="side-image" />
                      <div className="side-overlay">
                        <span className="side-read-time">{post.readTime}</span>
                      </div>
                    </div>
                    <div className="side-content">
                      <div className="side-meta">
                        <span className="side-category">{post.category}</span>
                      </div>
                      <h4 className="side-title">{post.title}</h4>
                      <div className="side-stats">
                        <span className="side-stat">
                          <img src={eyeIcon} alt="Views" />
                          {post.views}
                        </span>
                        <span className="side-stat">
                          <img src={heartIcon} alt="Likes" />
                          {post.likes}
                        </span>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Enhanced Main Content Grid */}
      <section className="content-section">
        <div className="content-container">
          <div className="content-layout">
            {/* Enhanced Articles Grid */}
            <div className="articles-section">
              <div className="articles-header">
                <div className="articles-title-wrapper">
                  <div className="articles-icon-container">
                    <img src={categoryIcon} alt="Articles" className="articles-icon" />
                  </div>
                  <div className="articles-title-content">
                    <h2 className="articles-title">Latest Teachings</h2>
                    <p className="articles-subtitle">Explore our collection of spiritual wisdom and guidance</p>
                  </div>
                </div>
                <div className="articles-filter-info">
                  <span className="filter-count">{regularPosts.length} Articles</span>
                  <div className="filter-indicator"></div>
                </div>
              </div>
              
              <div className="articles-grid">
                {regularPosts.map(post => (
                  <article key={post.id} className="article-card">
                    <div className="card-image-container">
                      <img src={post.image} alt={post.title} className="card-image" />
                      <div className="card-overlay">
                        <div className="overlay-content">
                          <div className="overlay-badges">
                            <span className="read-time-badge">{post.readTime}</span>
                            <div className="card-stats">
                              <span className="stat">
                                <img src={eyeIcon} alt="Views" />
                                {post.views}
                              </span>
                              <span className="stat">
                                <img src={heartIcon} alt="Likes" />
                                {post.likes}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-gradient"></div>
                    </div>
                    <div className="card-content">
                      <div className="card-header">
                        <div className="card-meta">
                          <span className="category-tag">{post.category}</span>
                          <div className="meta-separator"></div>
                          <span className="post-date">{new Date(post.date).toLocaleDateString()}</span>
                        </div>
                      </div>
                      <h3 className="card-title">{post.title}</h3>
                      <p className="card-excerpt">{post.excerpt}</p>
                      <div className="card-footer">
                        <div className="author-section">
                          <div className="author-avatar-small">
                            <img src={userIcon} alt="Author" />
                          </div>
                          <span className="author-name">{post.author}</span>
                        </div>
                        <button className="read-more-btn">
                          <span>Continue Reading</span>
                          <img src={arrowIcon} alt="Arrow" />
                        </button>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>

            {/* Enhanced Sidebar */}
            <aside className="blog-sidebar">
              {/* Trending Posts */}
              <div className="sidebar-widget trending-widget">
                <div className="widget-header">
                  <img src={fireIcon} alt="Trending" className="widget-icon" />
                  <h3 className="widget-title">Trending Now</h3>
                </div>
                <div className="trending-list">
                  {trendingPosts.map((post, index) => (
                    <div key={post.id} className="trending-item">
                      <div className="trending-rank">#{index + 1}</div>
                      <div className="trending-image">
                        <img src={post.image} alt={post.title} />
                      </div>
                      <div className="trending-content">
                        <h4 className="trending-title">{post.title}</h4>
                        <div className="trending-meta">
                          <span className="trending-views">
                            <img src={eyeIcon} alt="Views" />
                            {post.views}
                          </span>
                          <span className="trending-category">{post.category}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Categories with Icons */}
              <div className="sidebar-widget categories-widget">
                <div className="widget-header">
                  <img src={categoryIcon} alt="Categories" className="widget-icon" />
                  <h3 className="widget-title">Explore Topics</h3>
                </div>
                <div className="categories-list">
                  {categories.slice(1).map(category => (
                    <button
                      key={category}
                      className={`category-item ${selectedCategory === category ? 'active' : ''}`}
                      onClick={() => setSelectedCategory(category)}
                    >
                      <div className="category-info">
                        <span className="category-name">{category}</span>
                        <span className="category-count">
                          {blogPosts.filter(post => post.category === category).length} articles
                        </span>
                      </div>
                      <img src={arrowIcon} alt="Arrow" className="category-arrow" />
                    </button>
                  ))}
                </div>
              </div>

              {/* Popular Tags Cloud */}
              <div className="sidebar-widget tags-widget">
                <div className="widget-header">
                  <img src={tagIcon} alt="Tags" className="widget-icon" />
                  <h3 className="widget-title">Popular Tags</h3>
                </div>
                <div className="tags-cloud">
                  {popularTags.map(tag => (
                    <span key={tag} className="tag-item">{tag}</span>
                  ))}
                </div>
              </div>

              {/* Newsletter Signup */}
              <div className="sidebar-widget newsletter-widget">
                <div className="newsletter-content">
                  <div className="newsletter-icon">
                    <img src={shareIcon} alt="Newsletter" />
                  </div>
                  <h3 className="newsletter-title">Stay Enlightened</h3>
                  <p className="newsletter-text">
                    Receive weekly doses of ancient wisdom and spiritual insights directly in your inbox.
                  </p>
                  <div className="newsletter-form">
                    <input type="email" placeholder="Enter your email" className="newsletter-input" />
                    <button type="submit" className="newsletter-btn">
                      <span>Subscribe</span>
                      <img src={arrowIcon} alt="Subscribe" />
                    </button>
                  </div>
                  <div className="newsletter-stats">
                    <span>Join 5,000+ spiritual seekers</span>
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>
            <Contact />
      
    </div>
  );
};

export default Blog;